import { render } from "./BaseModal.vue?vue&type=template&id=1efddd03&scoped=true"
import script from "./BaseModal.vue?vue&type=script&lang=js"
export * from "./BaseModal.vue?vue&type=script&lang=js"

import "./BaseModal.vue?vue&type=style&index=0&id=1efddd03&scoped=true&lang=css"

import exportComponent from "/var/www/html/lynkto-vlan-user-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1efddd03"]])

export default __exports__